<!-- 三星跳轉頁面 /sw_page_redirect -->
<template>
  <div class="redirect_wrapper">
    <div class="content_container">
      <picture>
        <source
          media="(min-width: 768px)"
          :srcset="require('@/assets/imgs/logo@3x.png')"
        >
        <source
          media="(max-width: 320px)"
          :srcset="require('@/assets/imgs/logo.png')"
        >
        <img
          class="pxplus_logo"
          :src="require('@/assets/imgs/logo@2x.png')"
          alt="logo"
        >
      </picture>

      <div class="desc_para">
        請稍後，頁面即將跳轉...
      </div>

      <picture>
        <source
          media="(min-width: 768px)"
          :srcset="require('@/assets/imgs/img_redirect@3x.png')"
        >
        <source
          media="(max-width: 320px)"
          :srcset="require('@/assets/imgs/img_redirect.png')"
        >
        <img
          class="redirect_pic"
          :src="require('@/assets/imgs/img_redirect@2x.png')"
          alt="redirect"
        >
      </picture>
    </div>

    <div class="app_download">
      <p class="download_para">
        還沒安裝全支付APP嗎？
      </p>

      <div class="store_list">
        <a
          :href="appUrl.AOSDownloadUrl"
          class="store_item"
        >
          <picture>
            <source
              media="(min-width: 768px)"
              :srcset="require('@/assets/imgs/app/aos@3x.png')"
            >
            <source
              media="(max-width: 320px)"
              :srcset="require('@/assets/imgs/app/aos.png')"
            >
            <img
              class="app_pic"
              :src="require('@/assets/imgs/app/aos@2x.png')"
              alt="aos_store_badge"
            >
          </picture>
        </a>
        <a
          :href="appUrl.IOSDownloadUrl"
          class="store_item"
        >
          <picture>
            <source
              media="(min-width: 768px)"
              :srcset="require('@/assets/imgs/app/ios@3x.png')"
            >
            <source
              media="(max-width: 320px)"
              :srcset="require('@/assets/imgs/app/ios.png')"
            >
            <img
              class="app_pic"
              :src="require('@/assets/imgs/app/ios@2x.png')"
              alt="ios_store_badge"
            >
          </picture>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { SWPXPlusLink, SWPXPlusSDKLink, IOSDownloadUrl, AOSDownloadUrl } from '@/config/config';
import device from 'current-device';

export default {
  name: 'SWPageRedirect',
  setup () {
    const currentRoute = useRoute();
    const { scheme, source } = currentRoute.params;
    const urlParam = currentRoute.query;
    const queryStr = Object.keys(urlParam).length > 0
      ? '?' + Object.keys(urlParam).map((field) => `${field}=${urlParam[field]}`).join('&') : '';

    // sdk -> sdk 優先開 sdk 再開全支付
    // pxpay -> pxpay 優先開全支付再開 sdk
    const firstLink = (source === 'sdk') ? SWPXPlusSDKLink : SWPXPlusLink;

    let pxplusDownloadTimer = '';

    const appUrl = reactive({ IOSDownloadUrl, AOSDownloadUrl });

    const webRedirectToApp = async () => {
      // pxpay & sdk 會根據 firstLink 判斷要開的連結
      window.location.replace(`${firstLink}://${scheme}${queryStr}`);

      pxplusDownloadTimer = setTimeout(() => {
        window.location.href = AOSDownloadUrl;
      }, 3000);

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          if (pxplusDownloadTimer) clearTimeout(pxplusDownloadTimer);

          window.location.href = 'https://www.pxpayplus.com/';
        }
      });
    };

    onMounted(async () => {
      if (device.desktop()) {
        window.location.href = 'https://www.pxpayplus.com/download';

        return;
      }

      webRedirectToApp();
    });

    return {
      appUrl
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';

.redirect_wrapper {
  display: flex;
  flex-wrap: wrap;
  height: 100vh;

  .content_container {
    flex-grow: 1;
    overflow-y: hidden;
    padding: 32px 32px 0px;
    width: 100%;

    .pxplus_logo {
      height: 42px;
    }

    .desc_para {
      font-size: 17px;
      font-weight: 700;
      line-height: 24px;
      margin: 32px 0px 40px;
    }

    .redirect_pic {
      height: 192px;
      margin: 0px auto;
    }
  }

  .app_download {
    align-self: flex-end;
    background: #f8f8f8;
    min-height: 298px;
    padding: 24px 32px;
    width: 100%;

    .download_para {
      font-size: 16px;
      line-height: 24px;
      margin: 0px 0px 24px;
    }

    .store_list {
      .store_item {
        cursor: pointer;
        display: inline-block;
        white-space: nowrap;

        &:not(:last-of-type) {
          margin-right: 16px;
        }

        .app_pic {
          height: 54px;
        }
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .redirect_wrapper {
    .content_container {
      padding: 60px 60px 0px;

      .redirect_pic {
        margin: 0px;
      }
    }

    .app_download {
      padding: 24px 60px;

      .store_list {
        .store_item {
          &:not(:last-of-type) {
            margin-right: 32px;
          }

          .app_pic {
            height: 80px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 321px) and (max-width: 380px) {
  .redirect_wrapper {
    .content_container {
      .redirect_pic {
        height: 141px;
      }
    }

    .app_download {
      min-height: 153px;

      .store_list {
        .store_item {
          cursor: pointer;
          display: inline-block;

          &:not(:last-of-type) {
            margin-right: 16px;
          }

          .app_pic {
            height: 40px;
          }
        }
      }
    }
  }
}

</style>
